import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function useApi(path, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const load = useCallback(() => {
    if (!path) return;
    setError(false);
    api.get(path).then((r) => setData(r.data)).catch(() => setError(true));
  }, [path, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    load();
    const onBack = () => document.visibilityState === "visible" && setError((e) => { if (e) load(); return e; });
    window.addEventListener("online", load);
    document.addEventListener("visibilitychange", onBack);
    return () => {
      window.removeEventListener("online", load);
      document.removeEventListener("visibilitychange", onBack);
    };
  }, [load]);
  return { data, error, reload: load };
}

export const LoadError = ({ onRetry }) => (
  <div className="card-lux p-10 text-center" data-testid="load-error">
    <p className="text-white font-serif text-xl">We couldn't load this content.</p>
    <p className="text-slate-400 text-sm mt-2">Please check your connection and try again.</p>
    <button onClick={onRetry} className="btn-gold mt-6" data-testid="load-error-retry-btn">Try again</button>
  </div>
);
